import React from 'react'

import { Box, ListItem, Text } from '@domain-group/suit-theme'

interface ListItemWithIconProps {
  icon: React.ReactNode,
  label: string,
}

const ListItemWithIcon = (props: ListItemWithIconProps) => {
  const {
    icon, label,
  } = props

  return (
    <Box>
      <ListItem
        boxProps={{
          alignItems: 'center',
          padding: 'small',
          borderTop: 'none',
        }}
        disableHover
      >
        {icon && (
          <Box marginRight="large" width="auto" marginLeft="large">
            {icon}
          </Box>
        )}

        <Text color="bodyFontLightColor" fontSize="xsmall">
          {label}
        </Text>
      </ListItem>
    </Box>
  )
}

export default ListItemWithIcon
